<template>
  <el-table ref="table" :data="tableData" :show-summary="tableData.length > 1 && showSummary" size="small" :max-height="maxHeight">
    <template v-for="item in tableHeader">
      <table-column v-if="item.children && item.children.length" :key="item.id" :coloumn-header="item"></table-column>
      <el-table-column v-else :key="item.id" :label="item.label" :prop="item.prop" align="center"></el-table-column>
    </template>
  </el-table>
</template>

<script>
import TableColumn from "./tableColumn";
export default {
  props: {
    // 表格的数据
    tableData: {
      type: Array,
      required: true,
    },
    // 多级表头的数据
    tableHeader: {
      type: Array,
      required: true,
    },
    // 最大高度
    maxHeight: {
      type: [Number, String],
      default: "490"
    },
    showSummary: {
      type: Boolean,
      default: true
    }
  },
  components: {
    TableColumn,
  },
};
</script>